module.exports = __webpack_public_path__ + "media/assets/img/home/home_signin_right_img-c363f634e1c3a5eb165c82f38f92f513.png";